import React from 'react';
import { MonthView, WeekView, DayView, AgendaView, Calendar, type CalendarEvent } from '@/components/ui/Calendar';
import { CodeBlock } from '../CodeBlock';
import { SectionWrapper } from '../SectionWrapper';

export function CalendarSection() {
  const demoEvents: CalendarEvent[] = [
    { id: '1', title: 'Instagram Carousel: Workshop Teaser', start: new Date(), end: new Date(), networks: ['instagram'], status: 'scheduled', colorVariant: 'primary' },
    { id: '2', title: 'Blog Post Share: Managing Anxiety', start: new Date(new Date().setDate(new Date().getDate() + 1)), end: new Date(new Date().setDate(new Date().getDate() + 1)), networks: ['facebook','linkedin'], status: 'draft', colorVariant: 'accent' },
    { id: '3', title: 'X Thread: Tips for Parents', start: new Date(new Date().setDate(new Date().getDate() + 2)), end: new Date(new Date().setDate(new Date().getDate() + 2)), networks: ['x'], status: 'scheduled', colorVariant: 'secondary' },
  ];

  return (
    <SectionWrapper title="Calendar (Content Plan)">
        <div>
          <h3 className="text-lg font-semibold mb-4">Interactive Calendar</h3>
          <Calendar events={demoEvents} />
          <CodeBlock>
{`import { Calendar } from '@/components/ui/Calendar';

const events = [
  { id: '1', title: 'Instagram Carousel: Workshop Teaser', start: new Date(), end: new Date(), networks: ['instagram'], status: 'scheduled', colorVariant: 'primary' },
];

<Calendar events={events} initialView="month" />`}
          </CodeBlock>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">Month View</h3>
          <MonthView events={demoEvents} onEventClick={() => {/* TODO: Handle event click */}} />
          <CodeBlock>
{`import { MonthView } from '@/components/ui/Calendar';

<MonthView month={new Date()} events={events} onEventClick={handleClick} />`}
          </CodeBlock>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">Week View</h3>
          <WeekView events={demoEvents} onEventClick={() => {/* TODO: Handle event click */}} />
          <CodeBlock>
{`import { WeekView } from '@/components/ui/Calendar';

<WeekView weekStart={new Date()} events={events} onEventClick={handleClick} />`}
          </CodeBlock>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">Day View</h3>
          <DayView events={demoEvents} onEventClick={() => {/* TODO: Handle event click */}} />
          <CodeBlock>
{`import { DayView } from '@/components/ui/Calendar';

<DayView day={new Date()} events={events} onEventClick={handleClick} />`}
          </CodeBlock>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">Agenda View</h3>
          <AgendaView events={demoEvents} onEventClick={() => {/* TODO: Handle event click */}} />
          <CodeBlock>
{`import { AgendaView } from '@/components/ui/Calendar';

const start = new Date();
const end = new Date(start.getTime() + 7 * 24 * 60 * 60 * 1000);

<AgendaView from={start} to={end} events={events} onEventClick={handleClick} />`}
          </CodeBlock>
        </div>
    </SectionWrapper>
  );
}
